/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Correct_NoteInputs */

const en_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading speed too high - could not be corrected automatically`)
};

const fr_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse de lecture trop élevée - correction automatique impossible`)
};

const de_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesegeschwindigkeit zu hoch - konnte nicht automatisch korrigiert werden`)
};

const it_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità di lettura troppo alta - non è stato possibile correggerla automaticamente`)
};

const ru_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слишком высокая скорость чтения - не удалось исправить автоматически`)
};

const es_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de lectura demasiado alta - no se pudo corregir automáticamente`)
};

const zh_cn2_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读速度过高 - 无法自动更正`)
};

const ja_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み取り速度が速すぎます - 自動修正できませんでした`)
};

const hi_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पठन गति बहुत अधिक है - स्वचालित रूप से ठीक नहीं किया जा सका`)
};

const pt_pt2_auto_correct_note = /** @type {(inputs: Auto_Correct_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade de leitura demasiado alta - não foi possível corrigir automaticamente`)
};

/**
* | output |
* | --- |
* | "Reading speed too high - could not be corrected automatically" |
*
* @param {Auto_Correct_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct_note = /** @type {((inputs?: Auto_Correct_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Correct_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_correct_note(inputs)
	if (locale === "de") return de_auto_correct_note(inputs)
	if (locale === "it") return it_auto_correct_note(inputs)
	if (locale === "ru") return ru_auto_correct_note(inputs)
	if (locale === "es") return es_auto_correct_note(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_correct_note(inputs)
	if (locale === "ja") return ja_auto_correct_note(inputs)
	if (locale === "hi") return hi_auto_correct_note(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_correct_note(inputs)
	return en_auto_correct_note(inputs)
});